import React from 'react';
import { Row, Col, FormGroup } from 'react-bootstrap';
import { TextBox, CheckBox, RadioButton, IntBox, Switch } from 'fw/forms';
import { SetupTab } from 'areas/shared/pages/setup';
import { NotificationRecipientCombo, EmailTemplateCombo, NotificationTriggerCombo, NotificationDaysCombo } from 'areas/shared/controls'
import { Label } from 'fw/components';
import * as App from 'modules/app/App'
import * as API from 'modules/app/API'
import * as Formatting from 'fw/misc/Formatting'

class NotificationInfoTab extends SetupTab {
    initialForm() {
        return {
            content: "",
            description: "",
            active: true,
            startDate: Formatting.formatToday(),
            endDate: null,
            roles: [],
            rowVersion: null,
            fullEditable: true,
            notificationTypeCode: "USR"
        }
    }

    privileges() {
        return {
            add: App.hasPrivilege("AdminNotificationSetupAdd"),
            edit: App.hasPrivilege("AdminNotificationSetupEdit")
        }
    }

    urls() {
        return {
            get: API.App.url('/notificationSetup/getNotificationInfo'),
            save: API.App.url('/notificationSetup/saveNotificationInfo'),
            create: API.App.url('/notificationSetup/createNotification')
        }
    }

    getRequest(selectedId) {
        return {
            notificationId: selectedId
        }
    }

    saveRequest() {
        return {
            notificationId: this.props.selectedId,
            content: this.state.form.content,
            description: this.state.form.description,
            active: this.state.form.active,
            startDate: this.state.form.startDate,
            endDate: this.state.form.endDate,
            roles: this.state.form.roles,
            userTypeCode: this.state.form.userTypeCode,
            emailTemplateCode: this.state.form.emailTemplateCode,
            notificationTriggerCode: this.state.form.notificationTriggerCode,
            notificationTimeFrameId: this.state.form.notificationTimeFrameId,
            notificationFrequencyDays: this.state.form.notificationFrequencyDays,
            customFrequency: this.state.form.customFrequency,
            customFrequencyDays: this.state.form.customFrequencyDays,
            rowVersion: this.state.form.rowVersion,
            notificationTypeCode: "USR"
        }
    }

    ready = () => {
        this.focusControl && this.focusControl.focus();
    }

    renderForm() {
        return (
            <React.Fragment>
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <Label htmlFor="description" required>Notification name</Label>
                            <TextBox
                                name="description"
                                placeholder="Description"
                                maxLength={128}
                                required
                                ref={(c) => { this.focusControl = c; }}
                                disabled={!this.state.form.fullEditable} />
                            {/* <CheckBox name="active" label="Active" /> */}
                        </FormGroup>
                    </Col>
                    <Col md={1}>
                        &nbsp;
                    </Col>
                    <Col md={5}>
                        <Label></Label>
                        <Switch name="active" labelLeft="Inactive" labelRight="Active" bsStyle="primary" />
                    </Col>
                </Row>
                <Row>
                    <Col md={4}>
                        <FormGroup>
                            <Label htmlFor="description" required>Select the Notification Recipient</Label>
                            <NotificationRecipientCombo name="userTypeCode" required
                                disabled={!this.state.form.fullEditable}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={4}>
                        <FormGroup>
                            <Label htmlFor="description" required>Select an Email Template</Label>
                            <EmailTemplateCombo name="emailTemplateCode" 
                                emailTemplateType={this.state.form.notificationTypeCode}
                                disabled={!this.state.form.fullEditable}
                                required={this.state.form.fullEditable}  />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={4}>
                        <FormGroup>
                            <Label htmlFor="description" required>Select a Trigger Event</Label>
                            <NotificationTriggerCombo
                                name="notificationTriggerCode"
                                userTypeCode={this.state.form.userTypeCode}
                                notificationTypeCode={this.state.form.notificationTypeCode}
                                disabled={!this.state.form.fullEditable}
                                required={this.state.form.fullEditable} 
                                 />
                        </FormGroup>
                    </Col>
                    <Col md={3}>
                        <FormGroup>
                            <Label required>Select Before, After or N/A</Label><br />
                            <RadioButton name="notificationTimeFrameId" option={1} label="Before" disabled={!this.state.form.fullEditable} />
                            <RadioButton name="notificationTimeFrameId" option={2} label="After" disabled={!this.state.form.fullEditable} />
                            <RadioButton name="notificationTimeFrameId" option={0} label="N/A" disabled={!this.state.form.fullEditable} />
                        </FormGroup>
                    </Col>
                    <Col md={3}>
                        <FormGroup>
                            <Label htmlFor="roles" required>Select a Trigger Date</Label>
                            <NotificationDaysCombo
                                name="notificationFrequencyDays"
                                disabled={this.state.form.customFrequency || !this.state.form.fullEditable}
                            />
                            <CheckBox inline name="customFrequency"
                                label="Custom Frequency" disabled={!this.state.form.fullEditable}
                            />
                            {this.state.form.customFrequency &&
                                <IntBox name="customFrequencyDays" maxLength="4" positiveOnly placeholder="# Days" />
                            }
                        </FormGroup>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}

export default NotificationInfoTab; 



// WEBPACK FOOTER //
// ./src/areas/admin/notificationSetup/notificationInfo/NotificationInfoTab.js